/*
 * Arpy live header search.
 * Progressively enhances the custom header's EXISTING search panel
 * (.arpy-header-search-panel) to show instant, branded product results as you type.
 *
 * Does NOT modify the header markup (header-group.json) — it only hooks onto the
 * existing data-* attributes at runtime and injects a results list into the panel.
 * If anything fails (no fetch, network error, aborted), it silently does nothing and
 * the header's plain search form keeps working exactly as before.
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || !window.fetch || !window.DOMParser) return;

  var SECTION_ID = 'arpy-predictive-results';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;

  function suggestUrl() {
    var root = '/';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        root = Shopify.routes.root;
      }
    } catch (e) {}
    return root.replace(/\/+$/, '') + '/search/suggest';
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function initOne(wrap) {
    var input = wrap.querySelector('[data-arpy-header-search-input]');
    var panel = wrap.querySelector('[data-arpy-header-search-panel]');
    if (!input || !panel) return;
    if (panel.querySelector('[data-arpy-hsr]')) return; // already enhanced

    var results = document.createElement('div');
    results.className = 'arpy-hsr';
    results.setAttribute('data-arpy-hsr', '');
    panel.appendChild(results);

    var controller = null;

    function clear() {
      results.classList.remove('is-active', 'is-loading');
      results.innerHTML = '';
    }

    function render(html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-arpy-hsr-content]');
        var inner = content ? content.innerHTML.trim() : '';
        if (inner) {
          results.innerHTML = inner;
          results.classList.add('is-active');
        } else {
          clear();
        }
      } catch (e) {
        clear();
      }
      results.classList.remove('is-loading');
    }

    var run = debounce(function () {
      var q = (input.value || '').trim();
      if (q.length < MIN_CHARS) {
        clear();
        return;
      }

      if (controller) {
        try { controller.abort(); } catch (e) {}
      }
      controller = ('AbortController' in window) ? new AbortController() : null;

      results.classList.add('is-active', 'is-loading');

      var url = suggestUrl() +
        '?q=' + encodeURIComponent(q) +
        '&section_id=' + SECTION_ID +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(render)
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          clear(); // silent fallback — plain form still submits
        });
    }, DEBOUNCE_MS);

    input.addEventListener('input', run);
    // Native clear ("x") on a type=search input fires a 'search' event with empty value.
    input.addEventListener('search', function () {
      if (!input.value) clear();
    });
  }

  function init() {
    var wraps = document.querySelectorAll('[data-arpy-header-search]');
    for (var i = 0; i < wraps.length; i++) {
      initOne(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
